import { toast } from "sonner";

export function printLeaderboard({ title, subtitle, rows }) {
  const esc = (s) => String(s ?? "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));
  const body = rows.map((r) => `<tr>
    <td class="rank">${r.rank}${r.qualifier ? ' <span class="q">&#9733;</span>' : ""}</td>
    <td>${esc(r.player_name)}</td>
    <td class="num">${r.points}</td>
    <td class="num">${r.final_tables}</td>
    <td class="num">${r.events_played}</td>
    <td class="num">${r.wins}</td>
  </tr>`).join("");
  const html = `<!doctype html><html><head><meta charset="utf-8"><title>${esc(title)}</title>
  <style>
    * { box-sizing: border-box; }
    body { font-family: Georgia, 'Times New Roman', serif; margin: 40px; color: #111; }
    .head { text-align:center; border-bottom: 3px solid #b8860b; padding-bottom: 16px; margin-bottom: 24px; }
    .brand { letter-spacing: 6px; text-transform: uppercase; font-size: 12px; color: #b8860b; font-family: Arial, sans-serif; }
    h1 { margin: 8px 0 4px; font-size: 28px; }
    .sub { color: #555; font-size: 13px; font-family: Arial, sans-serif; }
    table { width: 100%; border-collapse: collapse; }
    th { text-align:left; font-family: Arial, sans-serif; font-size: 11px; text-transform: uppercase; letter-spacing: 1px; color:#b8860b; border-bottom: 2px solid #b8860b; padding: 8px 10px; }
    td { padding: 8px 10px; border-bottom: 1px solid #ddd; font-size: 14px; }
    td.num, th.num { text-align: right; }
    td.rank { font-weight: bold; width: 60px; }
    .q { color:#b8860b; }
    .foot { margin-top: 24px; text-align:center; color:#888; font-size: 11px; font-family: Arial, sans-serif; }
    @media print { body { margin: 12mm; } }
  </style></head><body>
    <div class="head"><div class="brand">Legends Poker League</div><h1>${esc(title)}</h1><div class="sub">${esc(subtitle)}</div></div>
    <table><thead><tr><th>Rank</th><th>Player</th><th class="num">Points</th><th class="num">Final Tables</th><th class="num">Played</th><th class="num">Wins</th></tr></thead><tbody>${body || '<tr><td colspan="6" style="text-align:center;color:#888;padding:40px">No standings</td></tr>'}</tbody></table>
    <div class="foot">&#9733; Qualified for the season Main Event &nbsp;&middot;&nbsp; Generated ${new Date().toLocaleDateString()}</div>
    <script>window.onload = function(){ window.print(); }</script>
  </body></html>`;
  const url = URL.createObjectURL(new Blob([html], { type: "text/html" }));
  const w = window.open(url, "_blank");
  if (!w) { toast.error("Please allow pop-ups to print or save as PDF"); URL.revokeObjectURL(url); return false; }
  setTimeout(() => URL.revokeObjectURL(url), 60000);
  return true;
}
